import { useTranslation } from 'react-i18next';

import { Form, Select } from '@arco-design/web-react';

import { MODEL_CATEGORY_FORM_FIELD } from '@/delivery-type-plugin/capabilities/maas-model-storage/modelCategory';
import { MODEL_CAPABILITY_OPTIONS } from '@/types/model-capabilities';

const FormItem = Form.Item;

/** 模型类型多选表单项 */
export function ModelCategoryFormItem() {
  const { t: translate } = useTranslation();

  return (
    <FormItem label={translate('data-center:model.type')} field={MODEL_CATEGORY_FORM_FIELD}>
      <Select
        mode="multiple"
        maxTagCount={2}
        options={MODEL_CAPABILITY_OPTIONS}
        placeholder={translate('data-center:model.category.placeholder')}
      />
    </FormItem>
  );
}
